import { render, staticRenderFns } from "./BookAppointmentWidget.vue?vue&type=template&id=13c67edd&scoped=true&"
import script from "./BookAppointmentWidget.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentWidget.vue?vue&type=style&index=0&id=13c67edd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c67edd",
  null
  
)

export default component.exports